import { render } from "./Papers.vue?vue&type=template&id=b7a88220"
import script from "./Papers.vue?vue&type=script&lang=js"
export * from "./Papers.vue?vue&type=script&lang=js"

import "./Papers.vue?vue&type=style&index=0&id=b7a88220&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__